import { render } from "./ArticleBlock.vue?vue&type=template&id=3e37f1c7&ts=true"
import script from "./ArticleBlock.vue?vue&type=script&lang=ts"
export * from "./ArticleBlock.vue?vue&type=script&lang=ts"

import "./ArticleBlock.vue?vue&type=style&index=0&id=3e37f1c7&lang=scss"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__